// extracted by mini-css-extract-plugin
export var measureBox = "_4m-0";